import { HttpClient } from '@adapters/HttpClient';

export interface ClientInvoice {
  id: number;
  team_id: number;
  erp_number: string | null;
  erp_id: string | null;
  date: string;
  period_month: string;
  reference_invoice_id: number | null;
  base_total: number;
  taxes_total: number;
  grand_total: number;
  pdf_url: string | null;
  xml_url: string | null;
  expired_at: string | null;
  extra_data: any | null;
  shipments: any[];
  team?: {
    id: number;
    name: string;
    vat: string;
  };
}

export interface ClientInvoicesResponse {
  data: ClientInvoice[];
  meta: {
    current_page: number;
    per_page: number;
    total: number;
  };
}

export class ClientInvoicesApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getInvoicesByTeamId(teamId: number, page = 1, perPage = 25): Promise<ClientInvoicesResponse> {
    const params: Record<string, any> = {
      per_page: perPage,
      page,
      'advanced_filters[filters][0][column]': 'team_id',
      'advanced_filters[filters][0][operator]': 'in',
      'advanced_filters[filters][0][value]': teamId,
      'advanced_filters[logic]': 'AND',
      'sorting[column]': 'id',
      'sorting[direction]': 'desc',
    };

    const response = await this.httpClient.get<ClientInvoicesResponse>('/invoices', params);
    return response;
  }
}
